import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-spinner',
	templateUrl: './spinner.component.html',
	styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {

	@Input() public width: string;
	@Input() public height: string;
	@Input() public border: string;

	@Input() public color: string;

	constructor() { }

	/**
	 * Setzt die Breite, Höhe, Linie sowie Farbe des Spinners.
	 */
	public ngOnInit(): void {
		document.documentElement.style.setProperty('--width', this.width ? this.width + 'px' : '64px');
		document.documentElement.style.setProperty('--height', this.height ? this.height + 'px' : '64px');
		document.documentElement.style.setProperty('--border', this.border ? this.border + 'px' : '6px');
		document.documentElement.style.setProperty('--color', this.color ? this.color : '#fff');
	}

}
